import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/**
 * Add / Edit category modal for the Video library.
 * All state lives in the parent (`VideoManager`).
 */
export default function VideoCategoryModal({
  open,
  editing,
  categoryName,
  setCategoryName,
  colors,
  onClose,
  onSave,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-800">
            {editing ? 'Edit Category' : 'Add Category'}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <Label>Category Name</Label>
            <Input
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="e.g. Surface Preparation"
              className="mt-1"
            />
          </div>
          <div className="flex gap-3 pt-2">
            <Button variant="outline" onClick={onClose} className="flex-1">
              Cancel
            </Button>
            <Button
              onClick={onSave}
              disabled={!categoryName.trim()}
              style={{ backgroundColor: colors.primary }}
              className="flex-1 text-white"
            >
              {editing ? 'Save' : 'Add'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
